import { gql } from '@apollo/client'

export const CreateUserForEmail = gql`
    mutation CreateUserForEmail($email: String!, $password: String!) {
        createUserForEmail(email: $email, password: $password) {
            accessToken
            refreshToken
            user {
                id
                username
                email
                avatar
                roles
                created
                updated
                lastActivity
                storage
                roomSlotsAvailable
                rooms {
                    id
                }
                invites {
                    id
                }
            }
        }
    }
`

export default CreateUserForEmail
